import { render, staticRenderFns } from "./Innovadores.vue?vue&type=template&id=2bebb4f7&"
import script from "./Innovadores.vue?vue&type=script&lang=js&"
export * from "./Innovadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports